import { createAction, props } from '@ngrx/store';
import { IProductV2, ICategoryItem } from '@care-portals/api-interfaces';

/* ----------------------------- Get Products ------------------------------ */
export const loadProducts = createAction(
  '[Product] Load Products',
  props<{ category?: string }>()
);

export const loadProductsSuccess = createAction(
  '[Product] Load Products Success',
  props<{ products: IProductV2[] }>()
);

export const loadProductsFailure = createAction(
  '[Product] Load Products Failure',
  props<{ error: any }>()
);

/* ----------------------------- Get Categories ------------------------------ */
export const loadCategories = createAction('[Product] Load Categories');

export const loadCategoriesSuccess = createAction(
  '[Product] Load Categories Success',
  props<{ categories: ICategoryItem[] }>()
);

export const loadCategoriesFailure = createAction(
  '[Product] Load Categories Failure',
  props<{ error: any }>()
);

/* ----------------------------- Get Product V2 ------------------------------ */
export const getProductV2 = createAction(
  '[Product] Get Product V2',
  props<{ id: string }>()
);

export const getProductV2Success = createAction(
  '[Product] Get Product V2 Success',
  props<{ product: IProductV2 }>()
);

export const getProductV2Failure = createAction(
  '[Product] Get Product V2 Failure',
  props<{ error: any }>()
);

export const loadProductVariants = createAction(
  '[Product] Load Product Variants',
  props<{ productId: string }>()
);

export const loadProductVariantsSuccess = createAction(
  '[Product] Load Product Variants Success',
  props<{ variants: any[] }>()
);

export const loadProductVariantsFailure = createAction(
  '[Product] Load Product Variants Failure',
  props<{ error: any }>()
);
